// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MavM","label":"styles_label__F9sHp"};